var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69051",
    "data-name": "Group 69051",
    transform: "translate(0.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38054",
    "data-name": "Group 38054",
    transform: "translate(-0.197)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14650",
    "data-name": "Rectangle 14650",
    width: 20,
    height: 20,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(2.122 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33385",
    "data-name": "Path 33385",
    d: "M18.768,17.912l-3.97-3.97a7.288,7.288,0,1,0-.857.857l3.97,3.97a.606.606,0,1,0,.857-.857ZM3.191,9.251a6.06,6.06,0,1,1,6.06,6.06,6.06,6.06,0,0,1-6.06-6.06Z",
    transform: "translate(-1.946 -1.946)",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.19a39d919b53242361b9f4fc8a479805.svg";
export { ForwardRef as ReactComponent };